import {} from "@outschool/ui-analytics";

import {
  CreateConciergeSupportIssueMutation,
  CreateConciergeSupportIssueMutationVariables
} from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { gql, useMutation } from "@outschool/ui-apollo";
import { useState } from "react";

import { LearnerInfo, buildUserMessage } from "./buildUserMessage";

const createConciergeSupportIssueMutation = gql`
  mutation CreateConciergeSupportIssue($userMessage: String!) {
    createConciergeSupportIssue(userMessage: $userMessage)
  }
`;

export function useConciergeRequest() {
  const { t } = useTranslation(
    "client\\components\\concierge\\useConciergeRequest"
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [createConciergeSupportIssue] = useMutation<
    CreateConciergeSupportIssueMutation,
    CreateConciergeSupportIssueMutationVariables
  >(createConciergeSupportIssueMutation);

  const submitRequest = async (
    inputValue: string,
    selectedLearner?: LearnerInfo
  ) => {
    if (!inputValue.trim()) {
      setErrorMessage(t("Please enter a message before sending"));
      return;
    }

    setIsSubmitting(true);
    setErrorMessage("");
    setSuccessMessage("");

    const userMessage = buildUserMessage(inputValue, selectedLearner);

    try {
      await createConciergeSupportIssue({ variables: { userMessage } });
      setSuccessMessage(
        t(
          "Your request has been sent! We’ll get back to you within 2 business days."
        )
      );
      return true; // Success
    } catch (error) {
      OsPlatform.captureError(error);
      setErrorMessage(
        t(
          "Sorry! We are not able to send your request at this time. Please try again."
        )
      );
      return false; // Error
    } finally {
      setIsSubmitting(false);
    }
  };

  const clearMessages = () => {
    setSuccessMessage("");
    setErrorMessage("");
  };

  return {
    isSubmitting,
    successMessage,
    errorMessage,
    submitRequest,
    clearMessages
  };
}
